/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbPayorSourceSummary } from './HchbPayorSourceSummary';
import {
    HchbPayorSourceSummaryFromJSON,
    HchbPayorSourceSummaryFromJSONTyped,
    HchbPayorSourceSummaryToJSON,
    HchbPayorSourceSummaryToJSONTyped,
} from './HchbPayorSourceSummary';

/**
 * 
 * @export
 * @interface HchbPayorTypeSummary
 */
export interface HchbPayorTypeSummary {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    active: boolean;
    /**
     * 
     */
    sources: Array<HchbPayorSourceSummary>;
}

/**
 * Check if a given object implements the HchbPayorTypeSummary interface.
 */
export function instanceOfHchbPayorTypeSummary(value: object): value is HchbPayorTypeSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('sources' in value) || value['sources'] === undefined) return false;
    return true;
}

export function HchbPayorTypeSummaryFromJSON(json: any): HchbPayorTypeSummary {
    return HchbPayorTypeSummaryFromJSONTyped(json, false);
}

export function HchbPayorTypeSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPayorTypeSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'active': json['active'],
        'sources': ((json['sources'] as Array<any>).map(HchbPayorSourceSummaryFromJSON)),
    };
}

export function HchbPayorTypeSummaryToJSON(json: any): HchbPayorTypeSummary {
    return HchbPayorTypeSummaryToJSONTyped(json, false);
}

export function HchbPayorTypeSummaryToJSONTyped(value?: HchbPayorTypeSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'active': value['active'],
        'sources': ((value['sources'] as Array<any>).map(HchbPayorSourceSummaryToJSON)),
    };
}

